export default {
    data: () => ({
        totalRows: 0,
        perPage: 1,
        limit: 10,
        disabled: false,
        currentPage: 1,
        deleteOk: false
    })
};
